import { CalendarOff, CalendarRange, Clock, FileSpreadsheet, LayoutDashboard, Settings, Users, Wallet, type LucideIcon } from "lucide-react";
import type { AppRole } from "@/lib/auth";

export interface NavItem {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  roles: AppRole[];
  badge?: "unassigned";
}

export interface NavSection {
  labelKey: string;
  items: NavItem[];
}

export const NAVIGATION: NavSection[] = [
  {
    labelKey: "nav.section_overview",
    items: [{ to: "/app", labelKey: "nav.today", icon: LayoutDashboard, roles: ["admin", "approver", "payroll"], badge: "unassigned" }],
  },
  {
    labelKey: "nav.section_time",
    items: [
      { to: "/app/times", labelKey: "nav.times", icon: Clock, roles: ["admin", "approver", "payroll"] },
      { to: "/app/accounts", labelKey: "nav.accounts", icon: Wallet, roles: ["admin", "approver", "payroll"] },
      { to: "/app/absences", labelKey: "nav.absences", icon: CalendarOff, roles: ["admin", "approver", "payroll"] },
      { to: "/app/payroll", labelKey: "nav.payroll", icon: FileSpreadsheet, roles: ["admin", "approver", "payroll"] },
    ],
  },
  {
    labelKey: "nav.section_admin",
    items: [
      { to: "/app/employees", labelKey: "nav.employees", icon: Users, roles: ["admin", "approver", "payroll"] },
      { to: "/app/settings", labelKey: "nav.settings", icon: Settings, roles: ["admin"] },
    ],
  },
];

export const ME_LINK = { to: "/me", labelKey: "nav.my_app", icon: CalendarRange };
